module.exports = __webpack_public_path__ + "08bfc9eff9ae37e51e0943e0701b4b77.svg";